import { createContext, useContext } from "react";
import type { Me } from "./useAuth";

interface AuthCtx {
  me: Me | null;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthCtx>({ me: null, logout: async () => {} });

export const useAuthCtx = () => useContext(AuthContext);
